import { Component } from '@angular/core';
import { NavbarComponent } from "../../partials/navbar/navbar.component";
import { FooterComponent } from "../../partials/footer/footer.component";
import { Title } from '@angular/platform-browser';
import { LanguageService } from '../../services/language.service';

@Component({
  selector: 'app-become-partner',
  standalone: true,
  imports: [NavbarComponent, FooterComponent],
  templateUrl: './become-partner.component.html',
  styleUrl: './become-partner.component.css'
})
export class BecomePartnerComponent {
  texts: any;
  constructor(private langService:LanguageService, private title:Title){
    this.texts = this.langService.getWebisteTexts().partners;

    if (this.langService.getLanguage() == 'es') {
      this.title.setTitle('PRINX - Convertirse en distribuidor') 
    }else{
      this.title.setTitle('PRINX - Become a partner')
    }
  }
}
